import { Controller } from "@hotwired/stimulus";
import { initToast } from "./customization/lib";
import Customization from "./customization";

// Connects to data-controller="site-builder--local-clear"

/*
    Responsible for clearing customization store once site is updated with latest customizations
 */
export default class extends Controller {
  static values = {
    reset: {
      type: Boolean,
      default: false,
    },
  };

  resetValueChanged() {
    this.removeImageCropperDetails();
    this.#setupToast();

    if (this.resetValue) {
      $(".tooltip:not('.tooltipstered')").tooltipster({
        maxWidth: 300,
      });
      this.toast.info.show(
        "Site update successful",
        "Bear with us, your changes will appear on your website soon!"
      );
      Customization.reset({ skip_url: true });
      Customization.saveStylesLocally();
      document.querySelectorAll(".customization-discard").forEach((el) => {
        el.classList.add("hidden");
      });
      document.querySelector('#discard-customizations').disabled = true;
    } else {
      this.toast.error.show(
        "Site update failed",
        "Something went wrong, please try again"
      );
    }
  }

  removeImageCropperDetails() {
    const logoHiddenDiv = document.querySelector('.logo-cropper-details');
    if (logoHiddenDiv) {
      logoHiddenDiv.remove();
    }

    const imageHiddenDivs = document.querySelectorAll('.image-cropper-details');
    if (imageHiddenDivs) {
      imageHiddenDivs.forEach(div => div.remove());
    }
  }

  #setupToast() {
    /*
        Stimulus value change callbacks are run before
        connect/initialize calls so this cannot
        be setup before.
     */
    if (!this.toast) initToast(this);
  }
}
